export default __webpack_public_path__ + "static/pain2-026f891fe2f1bb401f0c389d0ff5b514.jpg";